'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadBrowser = exports.pageScroll = exports.isWindowTop = exports.isWindowPopup = exports.isRightMouseClick = exports.isLocal = exports.isKey = exports.isCombinationPressed = exports.handleAriaKeyPress = exports.getScreenSize = exports.getCurrentScrollPosition = exports.getCrossBrowserEvent = exports.eventTarget = exports.eventKey = undefined;

var _keys = require('./keys');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
                                                                                                                                                                                                     * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * This document is the property of Nettoken Ltd.
                                                                                                                                                                                                     * It is considered confidential and proprietary.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * This document may not be reproduced or transmitted in any form,
                                                                                                                                                                                                     * in whole or in part, without the express written permission of
                                                                                                                                                                                                     * Nettoken Ltd.
                                                                                                                                                                                                     */


/**
 * @param {object} e
 *
 * @returns {integer}
 */
var eventKey = exports.eventKey = function eventKey(e) {
  return e.which || e.keyCode || e.charCode;
};

/**
 * @param {object} e
 *
 * @returns {HTMLElement}
 */
var eventTarget = exports.eventTarget = function eventTarget(e) {
  return e.target || e.srcElement;
};

/**
 * Atempts to return a valid event object.
 *
 * @returns {object}
 */
var getCrossBrowserEvent = exports.getCrossBrowserEvent = function getCrossBrowserEvent(event) {
  return event || window.event;
};

/**
 * Returns a number representing the current scroll distance on y-axis.
 *
 * @returns {integer}
 */
var getCurrentScrollPosition = exports.getCurrentScrollPosition = function getCurrentScrollPosition() {
  var _document = document,
      body = _document.body;

  var docEl = document.documentElement;
  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  return scrollTop;
};

/**
 * @returns {object}
 * @property {integer} height
 * @property {integer} width
 */
var getScreenSize = exports.getScreenSize = function getScreenSize() {
  var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  return { height: height, width: width };
};

/**
 * Meant to be used only with non-native button elements for accessibility.
 * This is used alongside the onKeyDown() or onKeyPress() method to check
 * whether "space" or "enter" were pressed. In such cases, we disable the
 * default action and allow the flow to continue.
 *
 * @example
 * <span
 *   onKeyDown={e => handleAriaKeyPress(e) && callback(e)}
 *   role="button"
 *   tabIndex="0">
 *   Clickable label!
 * </span>
 *
 * @param {object} event
 * @param {boolean} [cancel=true]
 *
 * @returns {boolean}
 */
var handleAriaKeyPress = exports.handleAriaKeyPress = function handleAriaKeyPress() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cancel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (event.type === 'click' || [_keys.REGULAR_KEYS.SPACE, _keys.REGULAR_KEYS.ENTER].includes(eventKey(event))) {
    if (cancel) event.preventDefault();
    return true;
  }
  return false;
};

/**
 * Helper function to strictly check if a combination of keys
 * is pressed. This is used to match keyboard shortcut patterns.
 *
 * @param {object} event
 * @param  {...string} keys
 *
 * @returns {boolean}
 */
var isCombinationPressed = exports.isCombinationPressed = function isCombinationPressed(event) {
  var keysRegular = [];
  var keysSpecial = [];

  // Split passed keys into special and regular.
  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i += 1) {
    var key = arguments.length <= i + 1 ? undefined : arguments[i + 1];
    if (_keys.SPECIAL_KEYS.includes(key)) {
      keysSpecial = [].concat(_toConsumableArray(keysSpecial), [key]);
    } else {
      keysRegular = [].concat(_toConsumableArray(keysRegular), [key]);
    }
  }

  // Check if special keys match pattern. This is false
  // if a key is pressed when it shouldn't or vice versa.
  for (var _i = 0; _i < _keys.SPECIAL_KEYS.length; _i += 1) {
    var _key = _keys.SPECIAL_KEYS[_i];
    var prop = void 0;

    switch (_key) {
      case 'alt':
        prop = 'altKey';
        break;

      case 'control':
        prop = 'ctrlKey';
        break;

      case 'meta':
        prop = 'metaKey';
        break;

      case 'shift':
        prop = 'shiftKey';
        break;

      // no default
    }

    if (prop && (keysSpecial.includes(_key) && !event[prop] || !keysSpecial.includes(_key) && event[prop])) return false;
  }

  // Check if regular keys match pattern. This should be in
  // practice always a single entry as Shift + D + F does not
  // make sense.
  for (var _i2 = 0; _i2 < keysRegular.length; _i2 += 1) {
    var _key2 = keysRegular[_i2];
    if (!isKey(event, _key2)) return false;
  }

  return true;
};

/**
 * Return whether the passed event key matches the requested key.
 * Works only for regular keys.
 *
 * @example isKey(event, 'f')
 *
 * @param {object} event
 * @param {string} key
 *
 * @returns {boolean}
 */
var isKey = exports.isKey = function isKey(event, key) {
  var eKey = eventKey(event);
  var code = _keys.REGULAR_KEYS[key.toUpperCase()];
  return eKey === code;
};

/**
 * @returns {boolean}
 */
var isLocal = exports.isLocal = function isLocal() {
  return window.location.hostname === 'localhost';
};

/**
 * @param {object} event
 *
 * @returns {boolean} Is the event a right mouse button click?
 */
var isRightMouseClick = exports.isRightMouseClick = function isRightMouseClick(event) {
  // Gecko (Firefox), WebKit (Safari/Chrome) and Opera.
  if ('which' in event && event.which === 3) {
    return true;
  }

  // IE, Opera.
  if ('button' in event && event.button === 2) {
    return true;
  }

  return false;
};

/**
 * @returns {boolean}
 */
var isWindowPopup = exports.isWindowPopup = function isWindowPopup() {
  return window.opener && window.opener !== window;
};

/**
 * @returns {boolean}
 */
var isWindowTop = exports.isWindowTop = function isWindowTop() {
  return window.top === window.self;
};

/**
 * Return the current page scroll values.
 *
 * @returns {object}
 * @property {integer} x
 * @property {integer} y
 */
var pageScroll = exports.pageScroll = function pageScroll() {
  var _document2 = document,
      body = _document2.body;

  var docEl = document.documentElement;
  var x = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  var y = getCurrentScrollPosition();
  return { x: x, y: y };
};

/**
 * Exported separately so we can mock it in tests.
 */
var reloadBrowser = exports.reloadBrowser = function reloadBrowser() {
  return window.location.reload();
};